/**
 * Created by yniran on 12/14/14.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        template = require("connection-templates/chatTab/chatContactsNoProfiles.tmpl"),
        ChatContactsNoProfiles = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {
        ChatContactsNoProfiles = Marionette.ItemView.extend({
            template: template,
            className: "contacts-profiles-list-no-matches-notification"
        });
    });

    return ChatContactsNoProfiles;
});

